import {
  Alert,
  Button,
  Link,
  blueBackground,
  grayBackground,
  grayWhite,
  largeMediaBreakpoint,
  smallMediaBreakpoint,
  spacingL,
  spacingM,
  spacingS,
  spacingXL,
  spacingXS,
  spacingXXL,
} from "@RooUI";
import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  padding-top: 60px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
  padding-bottom: 0px !important;
  background-color: ${grayWhite} !important;
  .site-header {
    box-shadow: 0px ${spacingXS} ${spacingS} 0px ${grayBackground};
  }
  overflow: unset !important;

  @media (max-width: ${smallMediaBreakpoint}) {
    margin-bottom: 100px;
  }
`;

export const LeftContainer = styled.div<{ $progress: boolean }>`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: ${({ $progress }) => ($progress ? "center" : "normal")};
  width: 50%;
  background-color: ${grayWhite};
  padding-bottom: 52px;
  @media (max-width: ${largeMediaBreakpoint}) {
    width: 100%;
  }
`;

export const LeftContainerInner = styled.div<{ $progress: boolean }>`
  margin-top: ${({ $progress }) => ($progress ? "68px" : "0")};
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: ${({ $progress }) => ($progress ? "center" : "normal")};
  width: 100%;
  max-width: ${({ $progress }) => ($progress ? "400px" : "100%")};
  @media (max-width: ${smallMediaBreakpoint}) {
    padding: 0 ${spacingXL};
    max-width: 100%;
  }
`;

export const RightContainer = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  gap: ${spacingS};
  width: 50%;
  background-color: ${blueBackground};
  padding: 0 82px;
  padding-bottom: 52px;
  div {
    text-align: center;
  }
  @media (max-width: ${largeMediaBreakpoint}) {
    display: none;
  }
`;

export const Image = styled.img`
  border-radius: ${spacingXL};
`;

export const ProgressBarContainer = styled.div`
  width: 50%;
  padding: 0 ${spacingXXL};
  position: absolute;
  top: 84px;
  &.breadcrumb-spacing {
    top: 118px;
  }
  @media (max-width: ${largeMediaBreakpoint}) {
    width: 100%;
  }
`;

export const Breadcrumb = styled(Link)`
  position: absolute;
  top: 84px;
  left: ${spacingXXL};
`;

export const HeadingContainer = styled.div<{ $progress: boolean }>`
  display: flex;
  flex-flow: column nowrap;
  gap: ${spacingL};
  text-align: center;
  white-space: nowrap;
  margin: ${({ $progress }) => ($progress ? "32px 0" : "64px 0 0")};
  @media (max-width: ${largeMediaBreakpoint}) {
    white-space: initial;
  }
`;

export const RadioGroupContainer = styled.div`
  width: 100%;
  label {
    margin-bottom: ${spacingL};
  }
  div {
    row-gap: ${spacingL};
    column-gap: ${spacingL};
    justify-content: center;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0 32px;
  margin-top: 28px;
`;

export const RegistrationButton = styled(Button)`
  min-width: 110px;
  max-width: 500px;
  width: 100%;
`;

export const ContainerTopMargin = styled.div`
  margin-top: ${spacingXXL};
  a {
    cursor: pointer;
  }
`;

export const InfoValuePropContainer = styled.div<{ $animate: boolean }>`
  position: absolute;
  top: 265px;
  display: flex;
  flex-flow: column nowrap;
  gap: 64px;
  transition: opacity ease-in-out 0.3s;
  opacity: ${(props) => (props.$animate ? 0 : 1)};
  div {
    display: flex;
    flex-flow: row nowrap;
    max-width: 440px;
    gap: ${spacingXXL};
    img {
      align-self: flex-start;
    }
  }
  span {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    gap: ${spacingS};
    text-align: left;
  }
`;

export const InputContainer = styled.div<{ $animate?: boolean }>`
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  gap: 24px;
  margin-top: 24px;
  transition: opacity ease-in-out 0.3s;
  opacity: ${(props) => (props.$animate ? 0 : 1)};
  span {
    display: flex;
    flex-flow: column nowrap;
    gap: ${spacingM};
  }
`;

export const RegistrationForm = styled.div`
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  .inputs {
    display: flex;
    flex-flow: column nowrap;
    gap: ${spacingXXL};
  }
  button {
    margin-top: 36px;
    margin-bottom: ${spacingXXL};
  }
  &.xxl-gap {
    gap: ${spacingXXL};
  }
`;

export const SupportingTextContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: ${spacingM};
  div {
    display: flex;
    flex-flow: column nowrap;
    gap: ${spacingS};
    text-align: left;
  }
  img {
    height: 55px;
    width: 55px;
  }
`;

export const Column = styled.div`
  width: 100%;
`;

export const BookCallContainer = styled.div`
  position: relative;
  p {
    text-align: left;
  }
  > div {
    text-align: left;
    position: relative;
    width: calc(100% - 10%);
    top: -8%;
    left: -5%;
  }
  ul {
    padding: 0 0 0 16px;
  }
`;

export const BookCallHeaderContainer = styled.div`
  margin-bottom: ${spacingM};
`;

export const ErrorAlert = styled(Alert)`
  width: 135%;
  margin-bottom: ${spacingXXL};
  @media (max-width: ${smallMediaBreakpoint}) {
    width: 100%;
  }
`;
